const makeCrcTable = () => {
  const table = [];
  for (let n = 0; n < 256; n += 1) {
    let c = n;
    for (let k = 0; k < 8; k += 1) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    table[n] = c >>> 0;
  }
  return table;
};

const crcTable = makeCrcTable();

const crc32 = (data) => {
  let crc = 0xffffffff;
  for (let i = 0; i < data.length; i += 1) {
    crc = crcTable[(crc ^ data[i]) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
};

const writeUint16 = (value) => {
  const bytes = new Uint8Array(2);
  const view = new DataView(bytes.buffer);
  view.setUint16(0, value, true);
  return bytes;
};

const writeUint32 = (value) => {
  const bytes = new Uint8Array(4);
  const view = new DataView(bytes.buffer);
  view.setUint32(0, value, true);
  return bytes;
};

export const createZipBlob = (files) => {
  const encoder = new TextEncoder();
  const fileParts = [];
  const centralDirectoryParts = [];
  let offset = 0;

  files.forEach((file) => {
    const nameBytes = encoder.encode(file.name);
    const checksum = crc32(file.bytes);
    const localHeader = [
      writeUint32(0x04034b50),
      writeUint16(20),
      writeUint16(0),
      writeUint16(0),
      writeUint16(0),
      writeUint16(0),
      writeUint32(checksum),
      writeUint32(file.bytes.length),
      writeUint32(file.bytes.length),
      writeUint16(nameBytes.length),
      writeUint16(0),
      nameBytes,
    ];

    fileParts.push(...localHeader, file.bytes);

    centralDirectoryParts.push(
      writeUint32(0x02014b50),
      writeUint16(20),
      writeUint16(20),
      writeUint16(0),
      writeUint16(0),
      writeUint16(0),
      writeUint16(0),
      writeUint32(checksum),
      writeUint32(file.bytes.length),
      writeUint32(file.bytes.length),
      writeUint16(nameBytes.length),
      writeUint16(0),
      writeUint16(0),
      writeUint16(0),
      writeUint16(0),
      writeUint32(0),
      writeUint32(offset),
      nameBytes,
    );

    offset += localHeader.reduce((sum, part) => sum + part.length, 0) + file.bytes.length;
  });

  const centralDirectoryOffset = offset;
  const centralDirectorySize = centralDirectoryParts.reduce((sum, part) => sum + part.length, 0);
  const endOfCentralDirectory = [
    writeUint32(0x06054b50),
    writeUint16(0),
    writeUint16(0),
    writeUint16(files.length),
    writeUint16(files.length),
    writeUint32(centralDirectorySize),
    writeUint32(centralDirectoryOffset),
    writeUint16(0),
  ];

  return new Blob([...fileParts, ...centralDirectoryParts, ...endOfCentralDirectory], { type: 'application/zip' });
};
